<template>
  <section>
    <!--工具条-->
    <VehiclesToolbar :buttonList="buttonList" @callFunction="callFunction"></VehiclesToolbar>

    <!--列表-->
    <el-table
      :data="vehicless"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      @selection-change="handleSelectionChange"
      style="width: 100%;"
    >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        fixed="left"
        label="操作"
        width="200">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="OwnedCompany" fixed="left" label="所属公司" width="260" sortable></el-table-column>
      <el-table-column prop="LicensePlateNumber" fixed="left" label="车牌号码" width="120" sortable></el-table-column>
      <el-table-column prop="SelfMadeNumber" fixed="left" label="车辆自编号" width="120" sortable></el-table-column>
      <el-table-column prop="LineChineseName" label="归属线路中文名称" width="180" sortable></el-table-column>
      <el-table-column prop="LineEnglishName" label="归属线路英文名称" width="180" sortable></el-table-column>
      <el-table-column prop="DriverName" label="司机" width="150" sortable></el-table-column>
      <el-table-column prop="TerminalsId" label="终端Id" width="100" sortable></el-table-column>
      <el-table-column prop="SimId" label="SimId" width="150" sortable></el-table-column>
      <el-table-column prop="Motorcade" label="车队" width="150" sortable></el-table-column>
      <el-table-column prop="LicensePlateColor" label="车牌颜色" width="100" sortable></el-table-column>
      <el-table-column prop="VehicleType" label="车辆类型" width="150" sortable></el-table-column>
      <el-table-column prop="CarColor" label="车身颜色" width="150" sortable></el-table-column>
      <el-table-column prop="FuelType" label="燃料类型" width="150" sortable></el-table-column>
      <el-table-column prop="CarLength" label="车长(单位毫米)" width="150" sortable></el-table-column>
      <el-table-column prop="CarWidth" label="车宽(单位毫米)" width="150" sortable></el-table-column>
      <el-table-column prop="CarHigh" label="车高(单位毫米)" width="150" sortable></el-table-column>
      <el-table-column prop="DrivingLicenseValidDate" label="行驶证有效日期" :formatter="formatDrivingLicenseValidDate" width="150" sortable></el-table-column>
      <el-table-column prop="IssuingAgencyName" label="发证机构名称" width="200" sortable></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="100" sortable></el-table-column>
      <el-table-column prop="Enabled" label="状态" width="200" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled  ? 'success' : 'danger'"
            disable-transitions
          >{{scope.row.Enabled ? "正常":"禁用"}}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--查看界面-->
    <el-dialog
      title="查看"
      :visible.sync="lookUpFormVisible"
      v-model="lookUpFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="lookUpForm" label-width="80px" ref="lookUpForm">
        <el-row>
          <el-col>
            <el-form-item label="所属公司" prop="CompanyId" label-width="110px">
              <el-select style="width: 100%;" v-model="lookUpForm.CompanyId" disabled placeholder="请选择所属公司">
                <el-option
                  v-for="item in companys"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.CompanyName"
                >
                  <span style="float: left">{{ item.CompanyName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="所属线路" prop="BusLinesId" label-width="110px">
              <el-select style="width: 100%;" v-model="lookUpForm.BusLinesId" disabled placeholder="请选择所属线路">
                <el-option
                  v-for="item in busLiness"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LineChineseName"
                >
                  <span style="float: left">{{ item.LineChineseName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.LineEnglishName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="司机" prop="DriverId" label-width="110px">
              <el-select style="width: 100%;" v-model="lookUpForm.DriverId" disabled placeholder="请选择司机">
                <el-option
                  v-for="item in drivers"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="lookUpForm.Enabled" disabled placeholder="请选择车辆状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车牌号码" prop="LicensePlateNumber" label-width="110px">
              <el-input v-model="lookUpForm.LicensePlateNumber" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="终端Id" prop="TerminalsId" label-width="110px">
              <el-input v-model="lookUpForm.TerminalsId" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="SimId" prop="SimId" label-width="110px">
              <el-input v-model="lookUpForm.SimId" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车队" prop="Motorcade" label-width="110px">
              <el-input v-model="lookUpForm.Motorcade" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车辆自编号" prop="SelfMadeNumber" label-width="110px">
              <el-input v-model="lookUpForm.SelfMadeNumber" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车牌颜色" prop="LicensePlateColor" label-width="110px">
              <el-input v-model="lookUpForm.LicensePlateColor" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车身颜色" prop="CarColor" label-width="110px">
              <el-input v-model="lookUpForm.CarColor" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
             <el-form-item label="车辆类型" prop="VehicleType" label-width="110px">
              <el-input v-model="lookUpForm.VehicleType" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
           <el-form-item label="燃料类型" prop="FuelType" label-width="110px">
              <el-input v-model="lookUpForm.FuelType" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车长(单位毫米)" prop="CarLength" label-width="110px">
              <el-input v-model="lookUpForm.CarLength" :disabled="true" />
            </el-form-item>
          </el-col>
           <el-col :span="10" style="float:right;">
            <el-form-item label="车宽(单位毫米)" prop="CarWidth" label-width="110px">
              <el-input v-model="lookUpForm.CarWidth" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车高(单位毫米)" prop="CarHigh" label-width="110px">
              <el-input v-model="lookUpForm.CarHigh" :disabled="true" />
            </el-form-item>
          </el-col>
           <el-col :span="10" style="float:right;">
            <el-form-item label="行驶证有效日期" prop="DrivingLicenseValidDate" label-width="110px">
              <el-date-picker v-model="lookUpForm.DrivingLicenseValidDate" type="date" disabled placeholder="选择行驶证有效日期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-form-item label="发证机构名称" prop="IssuingAgencyName" label-width="110px">
              <el-input v-model="lookUpForm.IssuingAgencyName" :disabled="true" />
            </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="lookUpFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col>
            <el-form-item label="所属公司" prop="CompanyId" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.CompanyId" placeholder="请选择所属公司">
                <el-option
                  v-for="item in companys"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.CompanyName"
                >
                  <span style="float: left">{{ item.CompanyName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="所属线路" prop="BusLinesId" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.BusLinesId" filterable placeholder="请选择所属线路">
                <el-option
                  v-for="item in busLiness"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LineChineseName"
                >
                  <span style="float: left">{{ item.LineChineseName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.LineEnglishName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="司机" prop="DriverId" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.DriverId" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in drivers"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="editForm.Enabled" placeholder="请选择车辆状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="10" style="float:right;">
            <el-form-item label="车牌号码" prop="LicensePlateNumber" label-width="110px">
              <el-input v-model="editForm.LicensePlateNumber" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="终端Id" prop="TerminalsId" label-width="110px">
              <el-input v-number-only v-model="editForm.TerminalsId" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="SimId" prop="SimId" label-width="110px">
              <el-input v-number-only v-model="editForm.SimId" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车队" prop="Motorcade" label-width="110px">
              <el-input v-model="editForm.Motorcade" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车辆自编号" prop="SelfMadeNumber" label-width="110px">
              <el-input v-model="editForm.SelfMadeNumber" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车牌颜色" prop="LicensePlateColor" label-width="110px">
              <el-input v-model="editForm.LicensePlateColor" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车身颜色" prop="CarColor" label-width="110px">
              <el-input v-model="editForm.CarColor" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
             <el-form-item label="车辆类型" prop="VehicleType" label-width="110px">
              <el-input v-model="editForm.VehicleType" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
           <el-form-item label="燃料类型" prop="FuelType" label-width="110px">
              <el-input v-model="editForm.FuelType" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车长(单位毫米)" prop="CarLength" label-width="110px">
              <el-input v-number-only v-model="editForm.CarLength" />
            </el-form-item>
          </el-col>
           <el-col :span="10" style="float:right;">
            <el-form-item label="车宽(单位毫米)" prop="CarWidth" label-width="110px">
              <el-input v-number-only v-model="editForm.CarWidth" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车高(单位毫米)" prop="CarHigh" label-width="110px">
              <el-input v-number-only v-model="editForm.CarHigh" />
            </el-form-item>
          </el-col>
           <el-col :span="10" style="float:right;">
            <el-form-item label="行驶证有效日期" prop="DrivingLicenseValidDate" label-width="110px">
              <el-date-picker v-model="editForm.DrivingLicenseValidDate" type="date" placeholder="选择行驶证有效日期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-form-item label="发证机构名称" prop="IssuingAgencyName" label-width="110px">
              <el-input v-model="editForm.IssuingAgencyName" />
            </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col>
            <el-form-item label="所属公司" prop="CompanyId" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.CompanyId" placeholder="请选择所属公司">
                <el-option
                  v-for="item in companys"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.CompanyName"
                >
                  <span style="float: left">{{ item.CompanyName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="所属线路" prop="BusLinesId" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.BusLinesId" filterable placeholder="请选择所属线路">
                <el-option
                  v-for="item in busLiness"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LineChineseName"
                >
                  <span style="float: left">{{ item.LineChineseName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.LineEnglishName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="司机" prop="DriverId" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.DriverId" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in drivers"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="addForm.Enabled" placeholder="请选择车辆状态">
                <el-option label="激活" value="true"></el-option>
                <el-option label="禁用" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车牌号码" prop="LicensePlateNumber" label-width="110px">
              <el-input v-model="addForm.LicensePlateNumber" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="终端Id" prop="TerminalsId" label-width="110px">
              <el-input v-number-only v-model="addForm.TerminalsId" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="SimId" prop="SimId" label-width="110px">
              <el-input v-number-only v-model="addForm.SimId" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车队" prop="Motorcade" label-width="110px">
              <el-input v-model="addForm.Motorcade" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车辆自编号" prop="SelfMadeNumber" label-width="110px">
              <el-input v-model="addForm.SelfMadeNumber" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车牌颜色" prop="LicensePlateColor" label-width="110px">
              <el-input v-model="addForm.LicensePlateColor" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="车身颜色" prop="CarColor" label-width="110px">
              <el-input v-model="addForm.CarColor" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车辆类型" prop="VehicleType" label-width="110px">
              <el-input v-model="addForm.VehicleType" />
            </el-form-item>
          </el-col>
           <el-col :span="10" style="float:right;">
            <el-form-item label="燃料类型" prop="FuelType" label-width="110px">
              <el-input v-model="addForm.FuelType" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="车长(单位毫米)" prop="CarLength" label-width="110px">
              <el-input v-number-only v-model="addForm.CarLength" />
            </el-form-item>
          </el-col>
           <el-col :span="10" style="float:right;">
             <el-form-item label="车宽(单位毫米)" prop="CarWidth" label-width="110px">
              <el-input v-number-only v-model="addForm.CarWidth" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
           <el-form-item label="车高(单位毫米)" prop="CarHigh" label-width="110px">
              <el-input v-number-only v-model="addForm.CarHigh" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="行驶证有效日期" prop="DrivingLicenseValidDate" label-width="110px">
              <el-date-picker v-model="addForm.DrivingLicenseValidDate" type="date" placeholder="选择行驶证有效日期" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-form-item label="发证机构名称" prop="IssuingAgencyName" label-width="110px">
              <el-input v-model="addForm.IssuingAgencyName" />
            </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  
  <!--绑定界面-->
    <el-dialog
      title="绑定"
      :visible.sync="bindingFormVisible"
      v-model="bindingFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="bindingForm" label-width="80px" :rules="bindingFormRules" ref="bindingForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="车牌号码" prop="LicensePlateNumber" label-width="110px">
              <el-input v-model="bindingForm.LicensePlateNumber" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="所属线路" prop="BusLinesId" label-width="110px">
              <el-select style="width: 100%;" v-model="bindingForm.BusLinesId" filterable placeholder="请选择所属线路">
                <el-option
                  v-for="item in busLiness"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LineChineseName"
                >
                  <span style="float: left">{{ item.LineChineseName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.LineEnglishName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="司机" prop="DriverId" label-width="110px">
              <el-select style="width: 100%;" v-model="bindingForm.DriverId" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in drivers"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="bindingFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="bindingSubmit" :loading="bindingLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog
      title="操作日记"
      :visible.sync="operateDataLogFormVisible"
      v-model="operateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getVehiclesListPage, removeVehicles, editVehicles, addVehicles, getCompanyListPage, getBusLinesListPage, getDriverListPage } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import VehiclesToolbar from "../../components/QueryToolbar/VehiclesToolbar";
import OperateDataLog from "../../components/OperateDataLog";

export default {
  components: { VehiclesToolbar,OperateDataLog },
  data() {
    return {
      filters: {
        companyId: "",
        busLinesId: "",
        licensePlateNumber: "",
        terminalsId: "",
        simId: ""
      },
      entityName: 'Vehicles', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      vehicless: [], //车辆列表
      companys: [], //企业列表
      busLiness: [], //线路列表
      drivers:[], //司机列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      lookUpFormVisible: false, //查看界面是否显示
      //查看界面数据
      lookUpForm: {
        Id: 0,
        CreateBy: "",
        CompanyId: 0,
        BusLinesId: 0,
        DriverId: 0,
        Enabled: false,
        LicensePlateNumber: "",
        SelfMadeNumber: "",
        LicensePlateColor: "",
        VehicleModel: "",
        VehicleType: "",
        TerminalsId: "",
        SimId: "",
        Motorcade: "",
        CarColor: "",
        FuelType: "",
        CarLength: 0,
        CarWidth: 0,
        CarHigh: 0,
        DrivingLicenseValidDate: null,
        IssuingAgencyName: ""
      },
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        CompanyId: [{ required: true, message: "请输入所属公司", trigger: "blur" }],
        BusLinesId: [{ required: true, message: "请输入归属线路", trigger: "blur" }],
        DriverId: [{ required: true, message: "请输入司机", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        LicensePlateNumber: [{ required: true, message: "请输入车牌号码", trigger: "blur" }],
        TerminalsId: [{ required: true, message: "请输入终端ID", trigger: "blur" }],
        SimId: [{ required: true, message: "请输入SimId", trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        CompanyId: 0,
        BusLinesId: 0,
        DriverId: 0,
        Enabled: false,
        LicensePlateNumber: "",
        SelfMadeNumber: "",
        LicensePlateColor: "",
        VehicleModel: "",
        VehicleType: "",
        TerminalsId: "",
        SimId: "",
        Motorcade: "",
        CarColor: "",
        FuelType: "",
        CarLength: 0,
        CarWidth: 0,
        CarHigh: 0,
        DrivingLicenseValidDate: null,
        IssuingAgencyName: ""
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        CompanyId: [{ required: true, message: "请输入所属公司", trigger: "blur" }],
        BusLinesId: [{ required: true, message: "请输入归属线路", trigger: "blur" }],
        DriverId: [{ required: true, message: "请输入司机", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
        LicensePlateNumber: [{ required: true, message: "请输入车牌号码", trigger: "blur" }],
        TerminalsId: [{ required: true, message: "请输入终端ID", trigger: "blur" }],
        SimId: [{ required: true, message: "请输入SimId", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        CompanyId: 0,
        BusLinesId: 0,
        DriverId: 0,
        Enabled: "true",
        LicensePlateNumber: "",
        SelfMadeNumber: "",
        LicensePlateColor: "",
        VehicleModel: "",
        VehicleType: "",
        TerminalsId: "",
        SimId: "",
        Motorcade: "",
        CarColor: "",
        FuelType: "",
        CarLength: 0,
        CarWidth: 0,
        CarHigh: 0,
        DrivingLicenseValidDate: null,
        IssuingAgencyName: ""
      },
      bindingFormVisible: false, //新增界面是否显示
      bindingLoading: false,
      bindingFormRules: {
        BusLinesId: [{ required: true, message: "请输入归属线路", trigger: "blur" }],
        DriverId: [{ required: true, message: "请输入司机", trigger: "blur" }]
      },
      //新增界面数据
      bindingForm: {
        CreateBy: "",
        CreateId: "",
        CompanyId: 0,
        BusLinesId: 0,
        DriverId: 0,
        Enabled: "true",
        LicensePlateNumber: "",
        LicensePlateColor: "",
        VehicleModel: "",
        VehicleType: "",
        TerminalsId: "",
        SimId: "",
        Motorcade: "",
        CarColor: "",
        FuelType: "",
        CarLength: 0,
        CarWidth: 0,
        CarHigh: 0,
        DrivingLicenseValidDate: null,
        IssuingAgencyName: ""
      },
      multipleSelection: []
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        companyId: item.companyId,
        busLinesId: item.busLinesId,
        licensePlateNumber: item.licensePlateNumber,
        terminalsId: item.terminalsId,
        simId: item.simId
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    //性别显示转换
    formatEnabled: function(row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    formatDrivingLicenseValidDate: function(row, column) {
      return !row.DrivingLicenseValidDate || row.DrivingLicenseValidDate == ""
        ? ""
        : util.formatDate.format(new Date(row.DrivingLicenseValidDate), "yyyy-MM-dd");
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getVehicles();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getVehicles();
    },
    queryVehicles(){
      this.page = 1;
      this.getVehicles();
    },
    //获取车辆列表
    getVehicles() {
      let _this = this;
      let para = {
        companyId: _this.filters.companyId,
        busLinesId: _this.filters.busLinesId,
        licensePlateNumber: _this.filters.licensePlateNumber,
        terminalsId: _this.filters.terminalsId,
        simId: _this.filters.simId,
        page: _this.page,
        pageSize: _this.pageSize,
      };
      _this.listLoading = true;
      getVehiclesListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.vehicless = res.data.response.data;
        _this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
      .then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        removeVehicles(para).then(res => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }

          this.getVehicles();
        });
      })
      .catch(() => {});
    },
    //显示查看界面
    handleLookUp() {
      this.lookUpFormVisible = true;
      this.lookUpForm = Object.assign({}, this.currentRow);
      this.lookUpForm.DriverId = this.lookUpForm.DriverId == 0? "": this.lookUpForm.DriverId;
    },
    //显示编辑界面
    handleEdit() {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.currentRow);
      this.editForm.DriverId = this.editForm.DriverId == 0? "": this.editForm.DriverId;
    },
    //显示绑定司机界面
    handleBinding() {
      this.bindingFormVisible = true;
      this.bindingForm = Object.assign({}, this.currentRow);
      this.bindingForm.DriverId = this.bindingForm.DriverId == 0? "": this.bindingForm.DriverId;
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CompanyName: "",
        Enabled: "true"
      };
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            editVehicles(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getVehicles();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //绑定
    bindingSubmit: function() {
      this.$refs.bindingForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.bindingLoading = true;
            let para = Object.assign({}, this.bindingForm);

            editVehicles(para).then(res => {
              if (util.isEmt.format(res)) {
                this.bindingLoading = false;
                return;
              }

              if (res.data.success) {
                this.bindingLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["bindingForm"].resetFields();
                this.bindingFormVisible = false;
                this.getVehicles();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addVehicles(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getVehicles();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
  mounted() {
    this.getVehicles();

    getCompanyListPage().then(res => {
      this.companys = res.data.response.data;
    });

    let pageSizePara = {
      pageSize: 100
    };
    getBusLinesListPage(pageSizePara).then(res => {
       this.busLiness = res.data.response.data;
    });

    let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
    getDriverListPage(driverPara).then(res => {
       this.drivers = res.data.response.data;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
